import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BsTelephone, BsHouse, BsWhatsapp} from "react-icons/bs";
//import ContactBg from '../assets/images/contact-bg.jpg';
import { ModalContext } from '../context/ModalContext';
import axiosInstance from '../axiosInstance';

const UnderBanner = () => {
    const modalContext = useContext(ModalContext);
    const [socialMediaData, setSocialMediaData] = useState(null);
    useEffect(() => {
      const fetchData = async () => {
          try {
              const res = await axiosInstance.get("/api/fetchsocialmedia"); // Adjust port if needed
              const fetchedData = res.data[0]; // Assuming data is an array
              setSocialMediaData(fetchedData);
          } catch (err) {
              console.error("Error fetching data:", err);
          }
      };
      fetchData();
    }, []);
    
    return (
        // <div className='schedule flex relative bg-amber-300 py-4 w-full h-full bg-no-repeat bg-cover bg-center bg-fixed' style={{backgroundImage:`url(${ContactBg})`}}>
        <div className='schedule flex relative bg-gray-100 py-4 w-full h-full bg-no-repeat bg-cover bg-center bg-fixed'>
          {/* <div className='absolute top-0 left-0 w-full h-full -z-0 bg-no-repeat bg-cover bg-center bg-fixed opacity-20' style={{backgroundImage:`url(${ContactBg})`}}></div> */}
          <div className='container mx-auto z-10'>
            <div className='w-full flex flex-col justify-center items-center align-middle md:flex-row gap-4 md:gap-10'>
              <button type="button" className='text-slate-800 text-base flex flex-col justify-center items-center align-middle space-y-3 px-4 py-4 hover:text-orange-500 transition-all duration-300 group' onClick={() => {
                modalContext.setShowEnquiryPopup(true);
              }}>
                  <span className='text-xl text-white p-3 rounded-md bg-slate-800 group-hover:bg-orange-500 group-hover:text-white group-hover:scale-105 transition-all duration-300'><BsTelephone /></span>
                  <span>Schedule a Call</span>
              </button>
              <div class="h-full min-h-[4em] w-px items-center bg-gradient-to-tr from-transparent via-neutral-500 to-transparent opacity-25 dark:via-neutral-400 hidden md:flex"></div>
              <button type="button" className=' text-slate-800 text-base flex flex-col justify-center items-center align-middle space-y-3 px-4 py-4 hover:text-orange-500 transition-all duration-300 group' onClick={() => {
                modalContext.setShowEnquiryPopup(true);
              }}>
                  <span className='text-xl text-white p-3 rounded-md bg-slate-800 group-hover:bg-orange-500 group-hover:text-white group-hover:scale-105 transition-all duration-300'><BsHouse /></span>
                  <span>Plan to Visit Site</span>
              </button>
              <div class="h-full min-h-[4em] w-px items-center bg-gradient-to-tr from-transparent via-neutral-500 to-transparent opacity-25 dark:via-neutral-400 hidden md:flex"></div>
              <Link to={socialMediaData?.whatsapp || "#"} target="_blank" className=' text-slate-800 text-base flex flex-col justify-center items-center align-middle space-y-3 px-4 py-4 hover:text-orange-500 transition-all duration-300 group'>
                  <span className='text-xl text-white p-3 rounded-md bg-slate-800 group-hover:bg-orange-500 group-hover:text-white group-hover:scale-105 transition-all duration-300'><BsWhatsapp /></span>
                  <span>Connect with Us</span>
              </Link>
            </div>
          </div>
        </div>
    );
}

export default UnderBanner;